import styled from "styled-components";

export const ItemList = styled.div`
    max-height: 150px;
    overflow-y: auto;
    padding: 4px 0;
`;

export const ItemListItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
`;

export const ItemListItemQuantity = styled.span`
    background-color: #e0e0e0;
    border-radius: 16px;
    padding: 2px 8px;
    font-size: 0.75rem;
`; 